import { createFileRoute } from "@tanstack/react-router"

import CSVExportPage from "@/app/export/csv/page"

export const Route = createFileRoute("/export/csv")({
  component: CSVExportPage,
})
